import React from "react";

const AnalyticsHeader = ({ lastUpdated, refreshing, onRefresh, exportButton }) => {
  return (
    <div className="analytics-header">
      <div className="analytics-header-content">
        <div>
          <h1>Analytics Dashboard</h1>
          <p>Monitor user activity and page views across your application</p>
          {lastUpdated && (
            <p className="last-updated">
              Last updated: {lastUpdated.toLocaleTimeString()}
            </p>
          )}
        </div>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          {exportButton}
          <button
            className="refresh-button"
            onClick={onRefresh}
            disabled={refreshing}
          >
            <svg
              className={refreshing ? "refresh-icon spinning" : "refresh-icon"}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <path
                d="M1 4v6h6M23 20v-6h-6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {refreshing ? "Refreshing..." : "Refresh"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsHeader;

